import React, { useState, useEffect } from 'react';
import api from '../api';

const STORAGE_KEY = 'sm_popup_dismissed';

export default function EmailPopup() {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    // Show after 5s if not dismissed before
    if (localStorage.getItem(STORAGE_KEY)) return;
    const t = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    localStorage.setItem(STORAGE_KEY, '1');
    try {
      await api.post('/auth/subscribe', { email: email.trim() });
    } catch (_) { /* still show success even if email fails */ }
    setSubmitted(true);
    setTimeout(() => setVisible(false), 4000);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20, backdropFilter: 'blur(2px)',
    }} onClick={dismiss}>
      <div style={{
        background: 'white', borderRadius: 20, maxWidth: 460, width: '100%',
        overflow: 'hidden', boxShadow: '0 25px 60px rgba(0,0,0,0.25)',
        position: 'relative',
      }} onClick={e => e.stopPropagation()}>
        {/* Top gradient banner */}
        <div style={{
          background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
          padding: '32px 32px 24px',
          textAlign: 'center', color: 'white',
        }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>&#127873;</div>
          <div style={{ fontSize: 13, fontWeight: 600, opacity: 0.85, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>
            Welcome to StyleMe
          </div>
          <div style={{ fontSize: 42, fontWeight: 900, lineHeight: 1, letterSpacing: -1 }}>
            10% OFF
          </div>
          <div style={{ fontSize: 16, opacity: 0.9, marginTop: 6 }}>your first order</div>
        </div>

        {/* Content */}
        <div style={{ padding: '24px 32px 32px' }}>
          {submitted ? (
            <div style={{ textAlign: 'center', padding: '16px 0' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>&#127881;</div>
              <div style={{ fontWeight: 800, fontSize: 20, marginBottom: 8 }}>You&apos;re all set!</div>
              <p style={{ color: '#6b7280', marginBottom: 16 }}>Use code at checkout:</p>
              <div style={{
                background: '#f0f0ff', border: '2px dashed #4f46e5',
                borderRadius: 10, padding: '12px 24px',
                fontFamily: 'monospace', fontSize: 24, fontWeight: 900,
                color: '#4f46e5', letterSpacing: 3,
              }}>WELCOME10</div>
            </div>
          ) : (
            <>
              <p style={{ textAlign: 'center', color: '#374151', marginBottom: 20, fontSize: 15 }}>
                Enter your email to unlock your exclusive discount code.
              </p>
              <form onSubmit={handleSubmit}>
                <input
                  type="email"
                  required
                  placeholder="your@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  style={{
                    width: '100%', padding: '13px 16px', borderRadius: 10,
                    border: '1.5px solid #e5e7eb', fontSize: 15,
                    boxSizing: 'border-box', marginBottom: 12,
                    outline: 'none',
                  }}
                />
                <button type="submit" style={{
                  width: '100%', padding: '14px', borderRadius: 10,
                  background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                  color: 'white', fontWeight: 700, fontSize: 16,
                  border: 'none', cursor: 'pointer',
                  boxShadow: '0 4px 15px rgba(79,70,229,0.3)',
                }}>
                  Get My 10% Off &rarr;
                </button>
              </form>
              <p style={{ textAlign: 'center', fontSize: 12, color: '#9ca3af', marginTop: 12 }}>
                No spam. Unsubscribe anytime.
              </p>
            </>
          )}
        </div>

        {/* Close button */}
        <button onClick={dismiss} style={{
          position: 'absolute', top: 12, right: 16,
          background: 'rgba(255,255,255,0.2)', border: 'none',
          color: 'white', fontSize: 20, cursor: 'pointer',
          borderRadius: '50%', width: 32, height: 32,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          lineHeight: 1,
        }}>&times;</button>
      </div>
    </div>
  );
}
